var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableComponent',_vm._g({attrs:{"tableKey":_vm.tableKey,"columns":_vm.columns,"dataSource":_vm.dataSource,"tableConfig":_vm.tableConfig}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }